import type { ReactNode } from "react";
import styles from "./PageShell.module.css";

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className={styles.shell}>
      <main className={styles.main}>{children}</main>
      <footer className={styles.footer} aria-hidden="true">
        <div className={styles.footerRule} />
      </footer>
    </div>
  );
}
